import './message/message';
import animation from './animation/animation';
import cookie from './cookie/cookie';
import detect from './detect/detect';
import layer from './layer/layer';
import lazyload from './lazyload/lazyload';
import player from './player/player';
import preloader from './preloader/preloader';
import scenebox from './scenebox/scenebox';
import cnb from './cnb/cnb';
import comment from './comment/comment';
import share from './share/share';
import trace from './trace/trace';
import util from './util/util';

if(!window.TweenMax) {
    lazyload.js('https://wstatic.plaync.co.kr/vendor/greensock/v1.19.1/TweenMax.min.js');
}

export default {
    animation,
    cnb,
    comment,
    cookie,
    detect,
    layer,
    lazyload,
    player,
    preloader,
    scenebox,
    share,
    trace,
    util
}